import 'assets/styles/Form.css';

const FormHeader = () => {
  return (
    <div className="form-header"></div>
  );
};

export default FormHeader;